import { useDispatch, useSelector } from 'react-redux'
import { RootState, TypedDispatch } from 'redux/store'
import orderAmountSlice from './order-amount-slice'
import { getOrderAmountError } from './order-amount-utils'
import { useMemo } from 'react'

const useOrderAmount = () => {
  const dispatch = useDispatch<TypedDispatch<RootState>>()
  const state = useSelector((state: RootState) => state.order.amount)

  return useMemo(
    () => ({
      value: state.value,
      error: state.error,
      isValid: !getOrderAmountError(state.value),
      setValue: (value: number) => {
        dispatch(orderAmountSlice.actions.setValue(value))
      },
      validate: () => {
        dispatch(orderAmountSlice.actions.validate())
      },
    }),
    [dispatch, state.error, state.value],
  )
}

export default useOrderAmount
